<template>
  <div>
    <audio :src='src' id="audio" autoplay="autoplay"></audio>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        src: '',
        voiceText: '',
      }
    },
    mounted() {},
    methods: {
      voicePlay(is_success,loadin) {
        if(is_success){
          if(loadin){ //'装入'语音
            //this.src =  'http://fchwcmgr-test.bee001.net/static/img/loadin.mp3'
            this.src =  '/static/img/loadin.mp3'
          }else{ //'成功'语音
            //this.src =  'http://fchwcmgr-test.bee001.net/static/img/success.mp3'
            this.src =  '/static/img/success.mp3'
          }
        }else{ //'错误'语音
          //this.src = 'http://fchwcmgr-test.bee001.net/static/img/0d3d2758969f4d3aa41564ac690ecdcf.mp3'
          this.src = '/static/img/0d3d2758969f4d3aa41564ac690ecdcf.mp3'
        }
        let audio = document.querySelector("#audio");
        audio.load();
        let playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
            audio.play()
          }).catch(() => {})
        }
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/voice.vue